var _excluded = ["title", "required", "description", "placeholder", "fieldName", "validation", "onChange", "className", "wrapperClassName", "disabled", "showPasswordReveal", "descriptionAboveInput", "children", "type"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from '../../Icon';
import withMapping from '../../../Context/withMapping';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import getNestedFieldvalue from '../getNestedFieldvalue';
import './style.scss';
var INPUT_TYPE_TEXT = 'text';
var INPUT_TYPE_PASSWORD = 'password';
export var TextField = function TextField(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    onChange = props.onChange,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$showPasswordRe = props.showPasswordReveal,
    showPasswordReveal = _props$showPasswordRe === void 0 ? false : _props$showPasswordRe,
    descriptionAboveInput = props.descriptionAboveInput,
    children = props.children,
    type = props.type,
    restProps = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    revealPassword = _React$useState2[0],
    setRevealPassword = _React$useState2[1];
  var inputType = type || INPUT_TYPE_TEXT;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && (value === undefined || value === null || value === '')) {
      return t(['webform.components.text_field.required', 'webform.required', 'webform_required']);
    }
  };
  var handleChange = function handleChange(e) {
    var handleChange = props.handleChange;
    if (handleChange) {
      handleChange(e);
    }
    if (onChange) {
      onChange(e);
    }
  };
  var _useExtendedFormikCon = useExtendedFormikContext(),
    values = _useExtendedFormikCon.values,
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var isTouched = getNestedFieldvalue(fieldName, touched);
  var error = getNestedFieldvalue(fieldName, errors);
  var value = getNestedFieldvalue(fieldName, values);
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('TextField', wrapperClassName, {
      'RevealPassword': inputType === INPUT_TYPE_PASSWORD
    }),
    touched: isTouched,
    title: title,
    error: error,
    required: required,
    fieldName: fieldName,
    description: description,
    descriptionAboveInput: descriptionAboveInput,
    displayRequiredIndicator: displayRequiredIndicator,
    descriptionId: descriptionId,
    errorId: errorId
  }, /*#__PURE__*/React.createElement(Field, _extends({}, restProps, {
    className: c(className, {
      'error': error && isTouched,
      'RevealPassword': inputType === INPUT_TYPE_PASSWORD
    }),
    id: fieldName,
    name: fieldName,
    validate: handleValidation,
    onKeyUp: handleChange,
    "aria-describedby": "".concat(errorId, " ").concat(descriptionId),
    "aria-invalid": Boolean(error && isTouched),
    type: revealPassword ? 'text' : inputType,
    value: value,
    disabled: disabled,
    required: required,
    placeholder: placeholder
  })), children, inputType === 'password' && showPasswordReveal && /*#__PURE__*/React.createElement(RevealPasswordButton, {
    onHandleRevealPassword: setRevealPassword,
    revealPassword: revealPassword
  }));
};
var RevealPasswordButton = function RevealPasswordButton(_ref) {
  var onHandleRevealPassword = _ref.onHandleRevealPassword,
    revealPassword = _ref.revealPassword;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onHandleRevealPassword(!revealPassword);
    },
    className: "RevealPasswordButton",
    type: "button",
    "aria-label": t('form.revealPassword')
  }, /*#__PURE__*/React.createElement(Icon, {
    name: revealPassword ? 'visibility_off' : 'visibility',
    flair: "outlined"
  }));
};
export default withMapping(TextField);